module.exports = { id: "heart", url: "/build/app/img/symbols.svg#heart", viewBox: "", toString: function() { return this.url; } };